const config = {
  API_BASE_URL: "https://backend-4yvg.onrender.com",
};

export default config;
